import { ArrowLeftIcon, ChevronLeftIcon } from '@heroicons/react/20/solid'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import { SEARCH_BOAT_DETAILS } from 'graphql/boat/queries'
import { t } from 'i18next'
import { ImageDisplay } from 'components/custom/ImageDisplay'
import loadingImage from 'assets/images/boat-loading.gif'
import { Carousel } from 'flowbite-react'

export default function BoatDetails() {
    const { id } = useParams()
    console.log('BOAT ID: ', id)
    const [boatList, setBoatList] = useState(null)
    const [boatCount, setBoatCount] = useState(0)
    const navigate = useNavigate()

    const [getBoatList, { loading: boatListLoading, error: boatListError }] = useLazyQuery(SEARCH_BOAT_DETAILS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.searchBoat.success && data.searchBoat.code === '200') {
                setBoatList(data.searchBoat.boats)
                setBoatCount(data.searchBoat.total_count)
            }
        },
    })

    useEffect(() => {
        console.log('Search boat===')
        searchBoat()
    }, [id])
    // Search users User List
    const searchBoat = () => {
        getBoatList({
            variables: {
                page: {
                    limit: 1,
                    offset: 0,
                },
                name: '',
                searchBoatId: id,
            },
        })
    }

    const handleBack = () => {
        navigate('/system-config')
    }

    return (
        <>
            <div className="mb-6 flex justify-normal items-center">
                <button
                    onClick={handleBack}
                    type="button"
                    className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <h3 className="text-lg font-bold leading-7 text-primary ps-2.5 pb-1">Boat details</h3>
            </div>
            {boatListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {boatListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch boat!')}</div>
                </div>
            )}
            {!boatListLoading && !boatListError && boatList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No boat found!')}</div>
                </div>
            )}
            {!boatListLoading && !boatListError && boatList?.length > 0 && (
                <div className="flex flex-wrap items-end justify-between gap-4">
                    <div className="max-sm:w-full sm:flex-1">
                        <div className="md:flex md:items-center md:justify-between md:space-x-5">
                            <div className="flex items-start space-x-5">
                                <div className="flex-shrink-0">
                                    <div className="relative">
                                        <ImageDisplay
                                            s3Key={boatList[0].details.images[0]?.s3_key}
                                            file=""
                                            classStyle="h-16 w-16 rounded-lg"
                                        />

                                        {/* <img
                      alt="Boat Image"
                      src={profileImage} // Replace with your boat image path
                      className="h-16 w-16 rounded-lg"
                    /> */}
                                        <span aria-hidden="true" className="absolute inset-0 rounded-lg shadow-inner" />
                                    </div>
                                </div>
                                <div className="pt-1.5">
                                    <h1 className="text-2xl font-bold text-gray-900">{boatList[0].name.en}</h1>
                                    <p className="text-sm font-medium text-gray-500">
                                        {boatList[0].details.boat_type.description.en}
                                    </p>
                                </div>
                            </div>
                            <div className="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                <a
                                    href={`/boats/boat-form/${boatList[0].id}`}
                                    className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary inline-flex justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                >
                                    {t('Edit Boat')}
                                </a>
                            </div>
                        </div>

                        <div className="mt-8">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-semibold leading-7 text-primary">
                                    {t('Boat Information')}
                                </h3>
                                <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                                    {t('Details about the boat, its capacity, and features.')}
                                </p>
                            </div>
                            <div className="mt-3 border-t border-gray-100">
                                <dl className="">
                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Boat Name')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].name.en}
                                        </dd>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Boat Type')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].details.boat_type.description.en}
                                        </dd>
                                    </div>
                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Registration Number')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].details.reg_number}
                                        </dd>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">{t('Capacity')}</dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].details.capacity} Passengers
                                        </dd>
                                    </div>
                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Seat Layout')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].seat_layout.description.en}
                                        </dd>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Boat Description')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].details.description.en}
                                        </dd>
                                    </div>
                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">{t('Status')}</dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {boatList[0].status.description.en}
                                        </dd>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Features & Amenities')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            <div className="flex flex-wrap gap-2">
                                                {boatList[0].details.features_amenities.map(feature => (
                                                    <span
                                                        key={feature.code}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-primary/[0.2] text-primary"
                                                    >
                                                        {feature.description.en}
                                                    </span>
                                                ))}
                                            </div>
                                        </dd>
                                    </div>
                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3 mb-2">
                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                            {t('Safety Equipment')}
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            <div className="flex flex-wrap gap-2">
                                                {boatList[0].details.safety_equipment.map(item => (
                                                    <span
                                                        key={item.code}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-primary/[0.2] text-primary"
                                                    >
                                                        {item.description.en}
                                                    </span>
                                                ))}
                                            </div>
                                        </dd>
                                    </div>

                                    {/* Add this after the existing boat information section */}
                                    {boatList?.length > 0 && boatList[0].weight_config && (
                                        <div className="mt-8">
                                            <div className="px-4 sm:px-0">
                                                <h3 className="text-lg font-semibold leading-7 text-primary">
                                                    {t('Luggage Configuration')}
                                                </h3>
                                                <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                                                    {t('Weight and luggage policies for international trips.')}
                                                </p>
                                            </div>
                                            <div className="mt-3 border-t border-gray-100">
                                                <dl className="divide-y divide-gray-100">
                                                    {/* Capacity Configuration */}
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Passengers Capacity')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.capacity.passengers}
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Crew Capacity')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.capacity.crew}
                                                        </dd>
                                                    </div>
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Captains Capacity')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.capacity.captains}
                                                        </dd>
                                                    </div>

                                                    {/* Weight Standards */}
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Infant Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.weight_standards.passengers
                                                                    .infant_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Child Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.weight_standards.passengers
                                                                    .child_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Adult Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.weight_standards.passengers
                                                                    .adult_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Senior Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.weight_standards.passengers
                                                                    .senior_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Default Luggage Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.weight_standards
                                                                    .default_luggage_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>

                                                    {/* Luggage Policy */}
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Extra Luggage Options (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            <div className="flex flex-wrap gap-2">
                                                                {boatList[0].weight_config.luggage_policy.extra_luggage_options_kg.map(
                                                                    (option, index) => (
                                                                        <span
                                                                            key={index}
                                                                            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-primary/[0.2] text-primary"
                                                                        >
                                                                            {option} kg
                                                                        </span>
                                                                    )
                                                                )}
                                                            </div>
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Max Extra Luggage Total (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.luggage_policy
                                                                    .max_extra_luggage_total_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>

                                                    {/* Safety Limits */}
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Max Passenger Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {
                                                                boatList[0].weight_config.safety_limits
                                                                    .max_passenger_weight_kg
                                                            }{' '}
                                                            kg
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Max Load Weight (kg)')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.safety_limits.max_load_kg} kg
                                                        </dd>
                                                    </div>

                                                    {/* Special Items Limits */}
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Max Strollers')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.special_items_limits.strollers}
                                                        </dd>
                                                    </div>
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3 mb-2">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Max Wheelchairs')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {boatList[0].weight_config.special_items_limits.wheelchairs}
                                                        </dd>
                                                    </div>
                                                </dl>
                                            </div>
                                        </div>
                                    )}
                                    {boatList?.length > 0 && boatList[0].details?.images?.length > 0 && (
                                        <div className="mt-0">
                                            <div className="px-4 sm:px-0 mt-6">
                                                <h3 className="text-lg font-semibold leading-7 text-primary">
                                                    {t('Photos')}
                                                </h3>
                                            </div>
                                            <div className="mt-3 border-t border-gray-100">
                                                <div className="h-56 sm:h-[550px] xl:h-80 2xl:h-96 mt-4">
                                                    <Carousel slide={false}>
                                                        {boatList[0].details?.images?.map(file => (
                                                            <div key={file.s3_key} className="h-full w-full">
                                                                <ImageDisplay
                                                                    s3Key={file.s3_key}
                                                                    file={file.file_data}
                                                                    classStyle="h-full w-full object-cover"
                                                                />
                                                            </div>
                                                        ))}
                                                    </Carousel>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
